import { useState } from 'react'

//Components
import SelectAddress from 'pages/dashboard/e-reporting/forms/components/reuseables/select-address/SelectAddress'

//Hoc
import withFetch from './withFetch'

//Context
import { STEPS, useFormMethod, useFormState } from "pages/dashboard/e-reporting/forms/context";

function PilihKotaProperti({ data }) {
  //Context
  const { setCurrentStep, formHandler, handlePrevState } = useFormMethod();
  const { disabledAll, form } = useFormState()

  const [selectedData, setSelectedData] = useState({
    ...form.kota_properti.value,
    value: form.kota_properti.value.id,
    label: form.kota_properti.value.name
  })

  const onNext = () => {
    handlePrevState()
    formHandler('kota_properti', selectedData)
    setCurrentStep(STEPS.pilihAreaProperti)
  }

  return (
    <SelectAddress
      question={'Di kota mana properti?'}
      placeholder="Tulis kota"
      required
      data={data}
      selectedData={selectedData}
      setSelectedData={setSelectedData}
      onNext={onNext}
      disabled={disabledAll}
    />
  )
}

export default withFetch(PilihKotaProperti)